// extracted by mini-css-extract-plugin
export default {"svgcontainer":"SvgContainer_svgcontainer__n9SWN","svg":"SvgContainer_svg__bADFx"};